import { api } from '@/utils/api';

// Tag CRUD mutations (existing)
export const useTagDeleteMutation = () => {
  const utils = api.useUtils();
  return api.tag.delete.useMutation({
    onSuccess: async () => {
      await Promise.all([utils.tag.all.invalidate(), utils.tag.id.invalidate()]);
    },
  });
};

export const useTagUpdateMutation = () => {
  const utils = api.useUtils();
  return api.tag.update.useMutation({
    onSuccess: async () => {
      await Promise.all([utils.tag.all.invalidate(), utils.tag.id.invalidate()]);
    },
  });
};

export const useTagCreateMutation = () => {
  const utils = api.useUtils();
  return api.tag.create.useMutation({
    onSuccess: async () => {
      await Promise.all([utils.tag.all.invalidate(), utils.tag.id.invalidate()]);
    },
  });
};

// Contact tag mutations (new)
export const useAddContactTagMutation = () => {
  const utils = api.useUtils();
  return api.tag.addContactTag.useMutation({
    onSuccess: async () => {
      // The pipeline board (stage.withContacts) renders each contact's tags,
      // so it must refresh too — not just the tag editor's contactTags query.
      await Promise.all([
        utils.tag.contactTags.invalidate(),
        utils.stage.withContacts.invalidate(),
      ]);
    },
  });
};

export const useRemoveContactTagMutation = () => {
  const utils = api.useUtils();
  return api.tag.removeContactTag.useMutation({
    onSuccess: async () => {
      await Promise.all([
        utils.tag.contactTags.invalidate(),
        utils.stage.withContacts.invalidate(),
      ]);
    },
  });
};

export const useBulkAddTagToContactsMutation = () => {
  const utils = api.useUtils();
  return api.tag.bulkAddTagToContacts.useMutation({
    onSuccess: async () => {
      await Promise.all([
        utils.tag.contactTags.invalidate(),
        utils.stage.withContacts.invalidate(),
      ]);
    },
  });
};
